import EyeOffIcon from '@heroicons/react/outline/esm/EyeOffIcon.js'

import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { useI18n } from '../i18n/providers/I18nProvider.js'

export const PostHiddenIndicator = ({
  isReply = false,
}: {
  isReply?: boolean
}) => {
  const intl = useI18n()

  return (
    <Tooltip>
      <Tooltip.Trigger className="inline-flex self-center">
        <EyeOffIcon
          className="relative"
          style={{ width: '1em', height: '1em', top: '0.125em' }}
        />
        &nbsp;
      </Tooltip.Trigger>
      <Tooltip.Panel>
        {isReply
          ? intl.$t({
              id: 'Post.PostHiddenIndicator.ReplyIndicator',
              defaultMessage:
                'People won’t see this reply. It will still be available for the author, admins, and moderators.',
            })
          : intl.$t({
              id: 'Post.PostHiddenIndicator.PostIndicator',
              defaultMessage:
                'People won’t see this post in their Feed. It will still be available for the author and in search results.',
            })}
      </Tooltip.Panel>
    </Tooltip>
  )
}
